module.exports = __webpack_public_path__ + "img/back_pocket_entry_length.1bf6b0ec.png";